module.exports = __webpack_public_path__ + "static/media/download-pdf-icon.1e0906ac.svg";